 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Epidemic":"Epidemic","Generalview":"Generalview","Webhook~formManage":"Webhook~formManage","Webhook":"Webhook","formManage":"formManage","BotIndex":"BotIndex","accountManage":"accountManage","statistics":"statistics","BotIntent":"BotIntent","Link":"Link","intentQa":"intentQa","entityManagement":"entityManagement","chatflow":"chatflow","dialogues~login~trainList":"dialogues~login~trainList","dialogues":"dialogues","trainList":"trainList","mnedit":"mnedit","main":"main","login":"login","help":"help","instantMessage":"instantMessage"}[chunkId]||chunkId) + "." + {"Epidemic":"ca5dd906","Generalview":"2bf3be9c","Webhook~formManage":"8786cfae","Webhook":"fb0eb751","chunk-28acd33c":"1d8c7966","chunk-db68785c":"714f5f49","formManage":"f5906cff","chunk-47ea601e":"9212e1b0","chunk-706b62b5":"cd76d9e5","chunk-338fd0c2":"cd3fd53b","BotIndex":"90df13fd","accountManage":"1d204e5f","chunk-5a948c01":"acbdac8a","chunk-fa211996":"627f88fd","chunk-b2cba676":"40b816bb","chunk-75f09958":"069dc454","chunk-ff12e92c":"4c49b2ba","chunk-4a072ae7":"8fde6a88","statistics":"b8397418","BotIntent":"0ca9aab8","Link":"4b8366a6","intentQa":"022a572f","chunk-e1d896b2":"a9cc3569","entityManagement":"75fd79d7","chatflow":"5ab5b178","chunk-99bb66b4":"d12ede2b","chunk-7b13cbd2":"a670299f","chunk-8f3bb828":"4beef75f","dialogues~login~trainList":"c57eb978","dialogues":"502b7419","trainList":"9fe8f7aa","mnedit":"ea651243","main":"a345ef05","chunk-6a0171f5":"c669cf35","login":"4758adcc","chunk-768a11e4":"51b2eb1f","chunk-84dba398":"fd26132e","chunk-c6923f8a":"1fa10532","help":"70473241","instantMessage":"584dbf3c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Epidemic":1,"Webhook~formManage":1,"Webhook":1,"formManage":1,"chunk-47ea601e":1,"BotIndex":1,"accountManage":1,"chunk-5a948c01":1,"chunk-fa211996":1,"chunk-b2cba676":1,"chunk-75f09958":1,"chunk-ff12e92c":1,"chunk-4a072ae7":1,"statistics":1,"BotIntent":1,"Link":1,"intentQa":1,"chunk-e1d896b2":1,"entityManagement":1,"chatflow":1,"chunk-99bb66b4":1,"chunk-7b13cbd2":1,"chunk-8f3bb828":1,"dialogues~login~trainList":1,"dialogues":1,"trainList":1,"mnedit":1,"main":1,"chunk-6a0171f5":1,"login":1,"chunk-768a11e4":1,"chunk-c6923f8a":1,"help":1,"instantMessage":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Epidemic":"Epidemic","Generalview":"Generalview","Webhook~formManage":"Webhook~formManage","Webhook":"Webhook","formManage":"formManage","BotIndex":"BotIndex","accountManage":"accountManage","statistics":"statistics","BotIntent":"BotIntent","Link":"Link","intentQa":"intentQa","entityManagement":"entityManagement","chatflow":"chatflow","dialogues~login~trainList":"dialogues~login~trainList","dialogues":"dialogues","trainList":"trainList","mnedit":"mnedit","main":"main","login":"login","help":"help","instantMessage":"instantMessage"}[chunkId]||chunkId) + "." + {"Epidemic":"3dfbbd5d","Generalview":"31d6cfe0","Webhook~formManage":"9aebfc9e","Webhook":"0144741e","chunk-28acd33c":"31d6cfe0","chunk-db68785c":"31d6cfe0","formManage":"311b4617","chunk-47ea601e":"816fe0d1","chunk-706b62b5":"31d6cfe0","chunk-338fd0c2":"31d6cfe0","BotIndex":"1b5ba024","accountManage":"b5b73d08","chunk-5a948c01":"15d8c8c5","chunk-fa211996":"20a65131","chunk-b2cba676":"9a1ab1a5","chunk-75f09958":"03e78820","chunk-ff12e92c":"77684135","chunk-4a072ae7":"0429dc62","statistics":"29434b11","BotIntent":"5851a751","Link":"c499c598","intentQa":"7baa2645","chunk-e1d896b2":"1dbb52b5","entityManagement":"89e48b9d","chatflow":"f7578aa4","chunk-99bb66b4":"fed48d25","chunk-7b13cbd2":"cf0bdf3f","chunk-8f3bb828":"6f96fc3f","dialogues~login~trainList":"507f86bb","dialogues":"d4033a0d","trainList":"6105bee9","mnedit":"7cce7e41","main":"5b82e200","chunk-6a0171f5":"fe4562c1","login":"6b7fb90e","chunk-768a11e4":"6c726019","chunk-84dba398":"31d6cfe0","chunk-c6923f8a":"811c80dd","help":"be64a35a","instantMessage":"c06c8b5d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.guoranbot.com/cdn-arsenal/dev/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
